var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBGgraphic2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 192,
    viewBox: "0 0 220 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.381 107.547C160.381 149.93 126.023 184.288 83.6397 184.288C41.2567 184.288 6.89844 149.93 6.89844 107.547",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 15.0473,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9157 72.9381C91.9157 41.7741 117.179 16.5107 148.343 16.5107C179.507 16.5107 204.771 41.7742 204.771 72.9382",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 30.0946
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63216 11.9963C14.0978 11.9963 24.2031 22.2701 24.2031 34.9435C24.2031 47.6168 14.0978 57.8906 1.63216 57.8906",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 22.571
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBGgraphic2);
export default __webpack_public_path__ + "static/media/BGgraphic2.5371167f7cf5cb235b52e1760ea018a9.svg";
export { ForwardRef as ReactComponent };